<script>
  export default{
    name: 'historico-lances',
    props: ['lote'],
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {}
  }
</script>

<template>
  <div class="historico-lances sys-table">
    <div class="table-content">
      <div class="header">
        <div class="col-apelido">Apelido</div>
        <div class="col-data">Data</div>
        <div class="col-valor">Valor</div>
      </div>
      <div class="body">
        <div class="item" v-for="lance in lote.lances">
          <div class="col-apelido">{{ lance.arrematante.apelido }}</div>
          <div class="col-data">{{ moment(lance.data.date).format('L') }} {{ moment(lance.data.date).format('LTS') }}</div>
          <div class="col-valor">R$ {{ lance.valor | moeda }}</div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// HistoricoLances.vue?82d5a70c